import { shouldRefreshTokens, shouldRemember } from '/b2b/authentication/state/Auth.selectors';

import AmplifyActions from '/b2b/authentication/state/amplify/Amplify.actions';
import AuthActions from '/b2b/authentication/state/Auth.actions';
import { refreshTokens as RefreshTokensService } from '/b2b/authentication/services';
import { changePassword } from '/b2b/authentication/services';

export const changeUserPassword =
    ({ userId, password: oldPassword, newPassword, revoke }) =>
    (dispatch, getState) => {
        const params = { userId };
        const rememberMe = shouldRemember(getState());
        dispatch(AuthActions.changePasswordBegin(params));
        return changePassword({ oldPassword, newPassword, rememberMe, revoke })
            .then(details => {
                dispatch(AuthActions.changePasswordSuccess(params, details));
                if (revoke && details) {
                    // We revoked the session and signed out and in again, so we have to reset the auth state
                    dispatch(AmplifyActions.nextStep(details));
                }
            })
            .catch(error => {
                const { code, message } = error;
                switch (code) {
                    case 'LimitExceededException': {
                        // Too many password change attempts
                        dispatch(AuthActions.changePasswordFailure(params, message));
                        throw message;
                    }
                }
                dispatch(AuthActions.changePasswordFailure(params, message));
                // Error here means that we were logged out or had tokens revoked
                return RefreshTokensService()
                    .then(session => {
                        shouldRefreshTokens(getState(), session) &&
                            dispatch(AuthActions.refreshTokens(session.tokens));
                        return session;
                    })
                    .catch(() => {
                        // Could not refresh tokens
                        dispatch(AuthActions.logout());
                    });
            });
    };
